import { ThemeColor } from 'src/@core/layouts/types'
import { IDynamicObject } from './types'
import { SetStateAction } from 'react'
import { UseFormReturn, UseFormSetValue } from 'react-hook-form'
import { commonListTypes } from 'src/types/apps/dataTypes'

interface ICourseSuccess {
  edit: string
}
export enum Address {
  Postal = 'POSTAL'
}
export enum StatusOFModule {
  Exempted = 'Exempted'
}
export enum FileSize {
  maxSize = 1024 * 500,
  maxSize3Mb = 3 * 1024 * 1024,
  maxSize20Mb = 20 * 1024 * 1024
}
export const manualDocumentName = 'RMS-Manual.pdf'
export interface OverrideDocumentsData {
  documentTypeCode: string
  file?: File | null | undefined
}
export enum FileError {
  fileType = 'image/pdf',
  fileSizeError = 'File is larger than 200 KB',
  fileTypeError = 'File type must be image/pdf'
}
export enum ProgramCategory {
  UG = 'UG',
  PG = 'PG'
}

export enum checkPaymentType {
  affordableValue = 'high',
  creditRiskValue = 'high'
}

export const CreditAffordableDataStatus: IDynamicObject = {
  high: 'High',
  medium: 'Medium',
  low: 'Low'
}

export interface IUploadFileContainer {
  setValue: UseFormSetValue<any>
  clearErrors?: any
  watch: UseFormReturn['watch']
  unregister: any
  errors?: any
  name: string
  title?: string
}
export interface ThroughPutDataParams {
  q?: string
  status?: string
  pageSize?: number
  pageNumber?: number
  academicYear?: number | string | null
  code?: string
  name?: string
  program?: string
  studyMode?: string
  search?: string
  year?: string
  semester?: string
  fromDate?: Date | null | undefined | string
  toDate?: Date | null | undefined | string
  programCode?: string
  enrolmentStatus?: string
  qualification?: string
  race: string
  gender?: string
  intake: string
  school: string
  classType: string
}

export interface IDocumentDialogPropsTypes {
  uploadDocumentApi: (param: any, documentCode: string) => void
  documentAdding?: boolean
  documentTypeList: Array<commonListTypes>
  documentBtnTitle?: string
  documentBtnProps?: any
  showCommentSection?: boolean
  studentData?: any
  programs?: any[]
  projectCode?: string
  isEditingDisabled?: boolean
}

export interface IUploadFileContainers {
  setValue: UseFormSetValue<any>
  clearErrors?: any
  watch: UseFormReturn['watch']
  unregister: any
  errors?: any
  name: string
  title?: string
  row?: InvoiceType
  viewFileLoader?: { [key: string]: boolean } | undefined
  handleView: (studentCode: string, fileName: string, fileCode: string) => void
  setDeletedObjects?: any
}

export const AcrWeightageType = {
  data: 'data'
}

export const AddressTypeData = [
  {
    isActive: true,
    id: 0,
    name: 'Postal',
    code: 'POSTAL'
  },
  {
    isActive: true,
    id: 1,
    name: 'Residential',
    code: 'RESIDENTIAL'
  }
]

export const keytype = {
  Enter: 'Enter'
}

export const projectStudentDocumentMessage: IDynamicObject = {
  'file-invalid-type': 'Only PNG, JPEG and PDF files are Allowed',
  'file-too-large': 'File is larger than 3 MB'
}
export const duplicateIdNumberMessage = 'Provided Id number address already exists'

export enum userInformationStatus {
  FirstNameRequired = ' First Name is Required',
  FirstNameError = 'First name must be character',
  FirstNameSpace = 'First name cannot contain spaces',
  MiddleNameError = 'Middle name must be character',
  MiddleNameSpace = 'Middle name cannot contain spaces',
  LastNameRequired = 'Last Name is Required',
  LastNameError = 'Last Name must be character',
  LastNameSpace = 'Last Name cannot contain spaces',
  ContactRequired = 'contact number is required',
  EmailRequired = 'email is required',
  StreetNameRequired = 'Address is required',
  CountryNameRequired = 'Country is required',
  CityNameRequired = 'City is required',
  CityNameMatch = 'City must be Characters',
  StateNameRequired = 'State is required',
  ZipcodeRequired = 'Zip is required',
  zipcodeNegative = 'Zip Code must be Number',
  zipCodeMin = 'Zip Code must be greater then 4',
  zipCodeMax = 'Zip Code must be less than or equal to 6',
  CostOfTrainingQuoteRequired = 'Cost Of TrainingQuoted is required',
  ContractCostRequired = 'Contract Cost is required',
  VarianceRequired = 'Variance  is required',
  VarianceDetailRequired = 'Variance Details  is required',
  PaymentTypeRequired = 'Payment Type is required',
  InstallmentNameRequired = 'InstallmentName is required',
  CurrencyRequired = 'Currency is required',
  DueAmountRequired = 'DueAmount is required',
  DateRequired = 'Date is required',
  AccommodationRequired = 'Accommodation  is required',
  CarHireRequired = 'Car Hire is required',
  FlightsRequired = 'Flights is required',
  VenueCostIncludedRequired = 'Venue Cost Included is required',
  CateringRequired = 'Catering Include is required',
  MobileNumber = 'Contact Number Required',
  NationalityStatus = 'Nationality Status is required',
  Gender = 'Gender is required',
  DateOfBirth = 'Date Of Birth is required',
  Race = 'Race is Required',
  Language = 'Home Language is required',
  PermanentResident = 'Permanent Resident  is required',
  Nationality = 'Nationality is required',
  DocumentType = 'Document Type is required',
  IdentificationNumber = 'Identification Number is required',
  DueAmountRequiredError = 'Amount Must be only digits',
  PaymentMode = 'Payment mode is required',
  program = 'Qualification Name is Required'
}
interface IOrientationStatusTypes {
  upComing: string
  completed: string
  onGoing: string
}
export const OrientationStatus: IOrientationStatusTypes = {
  upComing: 'Upcoming',
  completed: 'Completed',
  onGoing: 'On Going'
}

export const documentStatusArray: any = {
  application: [
    'SALES_APPROVED',
    'SALES_REJECT',
    'APPROVED',
    'REJECT',
    'ADMISSION_APPROVED',
    'ADMISSION_REJECT',
    'FINANCE_VERIFIED'
  ],
  enrolment: ['SALES_APPROVED', 'SALES_REJECT', 'ADMISSION_APPROVED', 'ADMISSION_REJECT', 'FINANCE_VERIFIED'],
  admission: ['APPROVED', 'REJECTED', 'ADMISSION_APPROVED', 'SALES_REJECT', 'ADMISSION_REJECT', 'FINANCE_VERIFIED'],
  operation: ['OPERATION_REJECT', 'OPERATION_APPROVED']
}

export enum OrientationMessages {
  nameRequire = 'Orientation Name is required',
  nameMessage = 'Invalid Orientation Name, first letter must be uppercase and special characters are not allowed',
  dateRequire = ' Date is required',
  timeRequire = 'Time is required',
  ugRequire = 'UG Qualifications are required',
  pgRequire = 'PG Qualifications are required',
  qualificationRequired = 'Qualification is required',
  orientationAgenda = 'Orientation Agenda File is required',
  fromTime = 'From Time is required',
  toTime = 'To Time is required'
}
interface ICourseStatusTypes {
  active: string
  inactive: string
  edit: string
  add: string
  courseNameRequired: string
  courseNameError: string
  courseCodeRequired: string
  courseNameMin: string
  courseCodeError: string
  courseTypeRequired: string
  semesterRequired: string
  yearRequired: string
}

interface IScheduleStatusTypes {
  edit: string
}

interface IScheduleStatus {
  Ongoing: string
  Notschedule: string
  completed: string
  upcoming: string
  addTask: string
  editTask: string
  delete: string
}
export interface IIntakeState {
  Studentq: string
  StudentPageSize: number
  StudentPageNumber: number
  IntakeCode: string
}
export enum InputTypes {
  TextArea = 'TEXTAREA',
  Input = 'INPUT'
}
export enum DataTypesEnum {
  String = 'string',
  Number = 'number'
}
export enum RoutingPaths {
  Home = '/',
  login = '/login',
  NotFound = '/404',
  ServerError = '/500'
}
export enum FileTypes {
  JSX = 'jsx',
  TSX = 'tsx'
}

export enum DocumentUploadMessages {
  success = 'Document Uploaded Successfully',
  error = 'Something Went Wrong',
  saveSuccess = 'Qualification Created Successfully'
}

export enum Regex {
  Alpha_Numeric = '(?!^[0-9 ]*$)(?!^[a-zA-Z- ]*$)^([a-zA-Z0-9- ]{5,})$',
  Numeric = '(?!^[0-9 ]*$)',
  Alpha = '^[a-zA-Z]+$',
  Pascal_Case = '^[A-Z][a-z A-Z0-9-]+$'
}
export const AcademicYear = Array.from(new Array(6), (_, i) => new Date().getFullYear() + i)
export enum IntakeValidation {
  ProgramName = 'Qualification name is required',
  IntakeName = 'Intake name is required',
  IntakeNameMin = 'Intake name must be at least 5 characters',
  IntakeNameMax = 'Intake name must be at most 25 characters',
  AcademicYear = 'Academic year is required',
  SelectYear = 'Select any  year',
  SelectSemester = ' select any semester',
  StartDate = 'start Date required',
  EndDate = 'End Date required',
  Select_course = 'Modules are required',
  IntakeError = 'Invalid Intake name, first letter must be uppercase and spacial characters not allow',
  studyMode = 'Study Mode is required'
}
export const enum EAddSchedule {
  Add = 'Schedule was added successfully for',
  Updated = 'Schedule was updated successfully for ',
  Error = 'All fields are required',
  AllDate = 'Digital Assessment Due Date , Individual Assignment Due Date and Exam Date All are Same',
  IndividualExam = ' Individual Assignment Due Date & Exam Date are Same',
  DigitalExam = 'Digital Assessment Due Date & Exam Date are same'
}
export const courseStatus: ICourseStatusTypes = {
  active: 'Active',
  inactive: 'In Active',
  edit: 'Module details updated successfully',
  add: 'New  module created successfully',
  courseNameRequired: 'Module name is required',
  courseNameError: 'Invalid Module name, first letter must be uppercase and spacial characters not allow',
  courseNameMin: 'Module name must be at least 5 characters',
  courseCodeRequired: 'Module code is required',
  courseCodeError: 'Module code should be alphanumeric',
  courseTypeRequired: 'Module type is required',
  semesterRequired: 'Semester is required',
  yearRequired: 'Year is required'
}

interface IWeekday {
  Sun: string
  Mon: string
  Tue: string
  Wed: string
  Thu: string
  Fri: string
  Sat: string
}

export const weekday: IWeekday = {
  Sun: 'SUN',
  Mon: 'MON',
  Tue: 'TUE',
  Wed: 'WED',
  Thu: 'THU',
  Fri: 'FRI',
  Sat: 'SAT'
}

interface ICreateProgramMessageTypes {
  programNameRequired: string
  programNameError: string
  codeRequired: string
  nqfLevelRequired: string
  noOfYearRequired: string
  categoryRequired: string
  studymodeError: string
  studymodeRequired: string
}
export const createProgramMessage: ICreateProgramMessageTypes = {
  programNameRequired: 'Qualification Name is Required',
  codeRequired: 'Short Code is Required',
  nqfLevelRequired: 'NQF Level is Required',
  noOfYearRequired: 'Number Of Years is Required',
  categoryRequired: 'Category is Required',
  studymodeRequired: 'study Mode is Required',
  studymodeError: 'Minimum 1 Study Mode is Required',
  programNameError: 'Invalid Qualification name, name must be Characters '
}

interface ISubProgramCommon {
  nameMatches: string
  nameRequired: string
  codeMatches: string
  codeRequired: string
  nqfLevelRequired: string
  Add: string
  Edit: string
}

export interface IGroupfilter {
  code?: string
  name?: string
  program?: string
  academicYear?: string | null | undefined
  studymode?: string
  status?: string
  year?: string
}

export const subProgramMessage: ISubProgramCommon = {
  nameRequired: 'Sub-Qualification Name is Required',
  nameMatches: 'Invalid Sub-Qualification name, first letter must be uppercase and spacial characters not allow',
  codeRequired: 'Code is Required',
  codeMatches: 'Invalid code, the value should be alphanumeric',
  nqfLevelRequired: 'NQF Level is Required',
  Add: 'sub-Qualification created successfully',
  Edit: 'sub-Qualification updated successfully'
}

interface IGroupMessageTypes {
  descriptionError: string
  descriptionRequired: string
}

export const editGroupMessage: IGroupMessageTypes = {
  descriptionError: 'Description should be alphanumeric ',
  descriptionRequired: 'Description is Required'
}

export const editSchedule: IScheduleStatusTypes = {
  edit: 'Economics Schedule Updated Successfully'
}
export enum StatusCode {
  Success = 200,
  Created = 201,
  Unauthorize = 401
}

interface IRmatProgramStatusTypes {
  active: boolean
  inactive: boolean
}

interface IRmatProgram {
  edit: string
  success: string
  programnameRequired: string
  maximumNumberRequired: string
  moodleCodeRequired: string
  moodleCodeMatches: string
  nameRequired: string
  nameMatches: string
  codeRequired: string
  codeMatches: string
  rmatTitle: string
  editRmatTitle: string
  moodelIdMin: string
  codeMin: string
  nameMin: string
  nameMax: string
}
interface IRmatStatusTypes {
  active: string
  inactive: string
}
export interface ICourseData {
  programCode: string
  code: string
  name: string
  type: string
  assignments: number
  assessment: number
  examination: number
}
interface IGroupTypes {
  active: boolean
  inactive: boolean
}
export const RmatStatusTypes: IRmatStatusTypes = {
  active: 'Active',
  inactive: 'In active'
}
export const rmatProgramStatus: IRmatProgramStatusTypes = {
  active: true,
  inactive: false
}

export const GroupStatusTypes: IRmatStatusTypes = {
  active: 'Active',
  inactive: 'In active'
}

export const groupStatus: IGroupTypes = {
  active: true,
  inactive: false
}

export const editProgramStatus: IRmatProgramStatusTypes = {
  active: true,
  inactive: false
}

export const messages = {
  searchErrorMessage: 'Type minimum 3 characters',
  error: 'Something went wrong',
  noRecords: 'No Records Found',
  documentFileValidation: 'Please upload any File',
  documentTypeValidation: 'Please Select Document Type',
  awsFileNotUploadMessage: 'Your file is not uploaded please reupload.',
  documentUploaded: 'Document uploaded successfully',
  documentFileType: 'Document File Type Updated Successfully',
  approve: 'Document Approve success',
  reject: 'Document rejected successfully',
  programDocumentTypeValidation: 'Please Select Document Type',
  programDocumentFileValidation: 'Please upload any File',
  FileTypeMessage: 'File Type Changed Successfully',
  loadingMessage: 'Data is Loading, it may take 5-10 minutes. Please wait...'
}

export const rmatProgram: IRmatProgram = {
  rmatTitle: 'Configure RMAT',
  editRmatTitle: 'Edit RMAT',
  edit: 'RMAT changes updated Successfully for',
  success: 'RMAT Configured Successfully for',
  programnameRequired: 'Qualification name is Required',
  maximumNumberRequired: 'Maximum Number of Attempts is Required',
  moodelIdMin: 'Moodle Id must be at least 5 characters',
  moodleCodeRequired: 'RMAT Moodle ID is required',
  moodleCodeMatches: 'Invalid ID, Id must be numeric',
  nameRequired: 'RMAT Name is required',
  nameMin: 'RMAT Name must be at least 5 characters',
  nameMax: 'RMAT Name must be at most 30 characters',
  nameMatches: 'Invalid RMAT name, first letter must be uppercase and spacial characters not allow ',
  codeRequired: 'RMAT Code is required',
  codeMatches: 'Invalid code, code must be numeric',
  codeMin: 'RMAT Code must be at least 5 characters'
}

interface IFilterThroughputParams {
  filterApplied: string
  filterCleared: string
}

export const filterThroughput: IFilterThroughputParams = {
  filterApplied: 'Filters applied successfully',
  filterCleared: 'Filters cleared successfully'
}

interface INewProgram {
  edit: string
}

export const newProgram: INewProgram = {
  edit: ' Qualification Updated Successfully'
}
interface IClassroom {
  edit: string
  online: string
}

export const classRoom: IClassroom = {
  edit: ' Course assigned Facilitator and Venue Successfully',
  online: 'ONLINE_REGENIUS'
}

export const allNumber = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th']

interface IIntakeStatusTypes {
  upComing: string
  completed: string
  onGoing: string
}
export const IntakeStatus: IIntakeStatusTypes = {
  upComing: 'Upcoming',
  completed: 'Completed',
  onGoing: 'On Going'
}
interface IIntakeType {
  add: string
  edit: string
  success: string
  editT: string
}
export const IntakeMessage: IIntakeType = {
  add: 'Create Intake',
  edit: 'Edit Intake',
  success: 'Intake created successfully',
  editT: 'Intake updated successfully'
}

export enum DocumentStatus {
  UploadPending = 'upload pending',
  Approved = 'approved',
  Submitted = 'submitted',
  Rejected = 'rejected',
  Pending = 'PENDING',
  OPERATION_APPROVED = 'OPERATION_APPROVED',
  OPERATION_REJECT = 'OPERATION_REJECT'
}

export interface IStudentList {
  id: number
  studentCode: string
  firstName: string
  lastName: string
}

interface ICourseSuccess {
  edit: string
}

export const courseSuccess: ICourseSuccess = {
  edit: 'Module edit updated successfully'
}

export const dataMessages = {
  success: 'Data Saved Successfully',
  error: 'Error While Saving Data'
}
export const noDataMessages = {
  message: 'No Data Available'
}

export const studentRiskValues = {
  defered: 'DEFERRED',
  other: 'OTHERS'
}

export const scheduleStatus: IScheduleStatus = {
  Ongoing: 'On Going',
  Notschedule: 'Not Schedule Yet',
  completed: 'Completed',
  upcoming: 'Upcoming',
  addTask: 'Add Task successfully',
  editTask: 'Edit Task updated successfully',
  delete: 'Schedule Deleted successfully'
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ICourseDetails {
  programId: number
  code: string
  name: string
  type: string
  assignments: number
  assessment: number
  examination: number
  isActive: boolean
}

export interface IGroupheadres {
  id: number
  minWidth: number
  flex: number
  name: string
  display?: string
  justifyContent?: string
}

export const Groupheadres = [
  { id: 1, minWidth: 50, flex: 0.15, name: '#' },
  {
    id: 2,
    minWidth: 145,
    flex: 0.25,
    name: 'Group Code'
  },
  {
    id: 3,
    flex: 0.1,
    minWidth: 230,
    maxWidth: 230,
    name: 'Group Name'
  },
  {
    id: 4,
    flex: 0.25,
    minWidth: 310,
    name: 'Qualification Name'
  },
  {
    id: 5,
    flex: 0.18,
    minWidth: 136,
    name: 'Academic Year'
  },
  {
    id: 6,
    flex: 0.25,
    minWidth: 114,
    name: 'Study Mode'
  },
  {
    id: 7,
    flex: 0.17,
    minWidth: 84,
    name: 'Year'
  },
  {
    id: 8,
    flex: 0.17,
    minWidth: 100,
    name: 'Semester'
  },
  {
    id: 9,
    flex: 0.17,
    minWidth: 151,
    name: 'Schedule Status'
  },
  {
    id: 10,
    display: 'flex',
    justifyContent: 'center',
    flex: 0.2,
    minWidth: 230,
    name: 'Actions'
  }
]

export const Scheduleheadres = [
  {
    id: 1,
    minWidth: 50,
    flex: 0.15,
    borderLeft: '4px solid green',
    fontWeight: 'bold',
    name: '#'
  },
  {
    id: 2,
    minWidth: 150,
    flex: 0.25,
    name: 'Module Code'
  },
  {
    id: 3,
    flex: 0.17,
    minWidth: 260,
    name: 'Module Name'
  },
  {
    id: 4,
    flex: 0.18,
    minWidth: 115,
    name: 'From'
  },
  {
    id: 5,
    flex: 0.18,
    minWidth: 115,
    name: 'To'
  },
  {
    id: 6,
    flex: 0.18,
    minWidth: 75,
    name: 'From'
  },
  {
    id: 7,
    flex: 0.18,
    minWidth: 75,
    name: 'To'
  },
  {
    id: 8,
    flex: 0.18,
    minWidth: 170,
    name: 'Digital Assessment Due Date'
  },
  {
    id: 9,
    flex: 0.18,
    minWidth: 190,
    name: 'Individual Assignment Due Date'
  },
  {
    id: 10,
    flex: 0.18,
    minWidth: 120,
    name: 'Exam Date'
  },
  {
    id: 11,
    flex: 0.2,
    minWidth: 140,
    name: 'Actions'
  }
]

export const AcademicHeaders = [
  { id: 1, minWidth: 50, flex: 0.15, name: '#' },
  {
    id: 2,
    minWidth: 145,
    flex: 0.25,
    name: 'Student ID'
  },
  {
    id: 3,
    flex: 0.17,
    minWidth: 230,
    name: 'Student Name'
  },
  {
    id: 4,
    flex: 0.25,
    minWidth: 150,
    name: 'Contact '
  },
  {
    id: 5,
    flex: 0.18,
    minWidth: 250,
    name: 'Qualification Name'
  },
  {
    id: 6,
    flex: 0.25,
    minWidth: 114,
    name: 'Study Type'
  },
  {
    id: 7,
    flex: 0.17,
    minWidth: 84,
    name: 'Student Type'
  },
  {
    id: 8,
    flex: 0.17,
    minWidth: 150,
    name: 'Status'
  },
  {
    id: 9,
    flex: 0.17,
    minWidth: 100,
    name: 'Actions'
  }
]

export const ProgressReportHeaders = [
  { id: 1, minWidth: 50, flex: 0.15, name: '#' },
  {
    id: 2,
    minWidth: 145,
    flex: 0.25,
    name: 'Student ID'
  },
  {
    id: 3,
    flex: 0.17,
    minWidth: 230,
    name: 'Student Name'
  },
  {
    id: 4,
    flex: 0.25,
    minWidth: 150,
    name: 'Contact '
  },
  {
    id: 5,
    flex: 0.18,
    minWidth: 250,
    name: 'Qualification Name'
  },
  {
    id: 6,
    flex: 0.18,
    minWidth: 250,
    name: 'Intakes'
  },
  {
    id: 7,
    flex: 0.25,
    minWidth: 120,
    name: 'Study Type'
  },
  {
    id: 8,
    flex: 0.17,
    minWidth: 150,
    name: 'Student Type'
  },
  {
    id: 9,
    flex: 0.17,
    minWidth: 150,
    name: 'Status'
  },
  {
    id: 10,
    flex: 0.17,
    minWidth: 100,
    name: 'Actions'
  }
]

export const studyModeForNonContractClasses = {
  Online: 'ONLINE'
}

export const documentTypeCode = {
  acceptance: 'ACCEPTANCE-LETTER',
  confirmation: 'CONFIRMATION-LETTER',
  declaration: 'DECLARATIONFORM',
  PaymentProof: 'PAYMENTPROOF',
  welcome: 'WELCOME-LETTER',
  quote: 'QUOTE',
  debitorder: 'DEBITORDER',
  TermsAndConditions: 'TERMSANDCONDITION',
  TermsAndConditionsCode: 'TERMS&CONDITION',
  Study_Flexi_Calculation: 'STUDY-FLEXI-CALCULATION',
  Study_Flexi_Agreement: 'STUDY-FLEXI-AGREEMENT'
}

export const operationRole = ['Admin', 'Operation']
export const studentApplicationSubStatus: IDynamicObject = {
  'SUB-DEFERRED-FEES_PENDING': 'FEES_PENDING',
  'SUB-CANCELLED-FEES_PENDING': 'FEES_PENDING',
  MODULES_ASSIGNED: 'Modules Assigned',
  RE_INSTATED: 'Re-Instated',
  ADMITTED: 'Admitted',
  DEFERRED: 'Deferred',
  MOVING_AWAY: 'Moving Away',
  FAMILY_REASONS: 'Family Reasons',
  GENERAL: 'General',
  MOVED_TO_ANOTHER_QUALIFICATION: 'Moved to Another Qualification',
  'SUB-INACTIVE-UNRESPONSIVE': 'Inactive Unresponsive',
  'SUB-INACTIVE-NOT-CONTACTABLE': 'Inactive Not Contactable',
  'SUB-FEES-PENDING-DO-NOT-SUPPLY-ACADEMIC-RECORD': 'Fees Pending Do not Supply Academic Record',
  'SUB-UN-SATISFIED': 'Un-Satisfied',
  'SUB-GRADUATED': 'Graduated',
  'SUB-MARKS-NOT-RETRIEVED': 'Marks not retrieved',
  'SUB-LEAD-REFUNDED': 'Lead Refunded',
  'SUB-ATTENDED': 'Attended',
  'SUB-COMPLETED': 'Completed',
  'SUB-EXPELLED': 'Expelled',
  'SUB-DECEASED': 'Deceased',
  'SUB-GRADUATED-FEES-PENDING': 'Outstanding Fees',
  'SUB-SUSPENDED': 'Governing Bodies',
  DEFD_FEES_PENDING: 'Fees Pending',
  CANC_FEES_PENDING: 'Fees Pending',
  FEES_PENDING: 'Outstanding Fees',
  SALES_OVERPROMISED: 'Sales Overpromised Component Not Offered',
  ACADEMIC_EXPECT_NOT_MET: 'Academic expectations not met',
  RELOCATING: 'Relocating',
  WORK_CONSTRAINTS: 'Work Constraints',
  HEALTH_CONSTRAINTS: 'Health Constraints',
  FINANCIAL_CONSTRAINTS: 'Financial Constraints',
  'SUB-COMPLETED-FEES-PENDING': 'Outstanding Fees',
  PENDING_ADMISSION_DOC: 'Pending Admission Documents',
  QUALIF_REG_PER_LAPSED: 'Qualification Registration Period Lapsed',
  LEGAL: 'Legal',
  CANC_QUALI_REG_PER_LAPSED: 'Qualification Registration Period Lapsed',
  CANC_PROG_DUR_EXCEEDED: 'Program Duration Exceeded',
  CANC_OTHER: 'Other'
}

export const studentApplicationAllStatus: IDynamicObject = {
  'BURSARY-APP-FEE-PEND': 'Bursary Application Fee Pending',
  'APP-FEE-DOC-VER-PEND': 'Application Fee Verification Pending',
  'RESUB-APP-FEE-PROOF': 'Resubmit Application Fee POP',
  'APP-FEE-VER-PEND': 'Application Fee Verification Pending',
  'APP-FEE-ACCEPTED': 'Application Fee Accepted',
  'APP-FEE-REJECTED': 'Application Fee Rejected',
  'APP-ENROLLED': 'Application Confirmed',
  'APP-DOC-VER-PEND': 'Application Document Verification Pending',
  'APP-DOC-REQUESTED': 'Application Documents Requested',
  'APP-DOC-ACCEPTED': 'Application Documents Accepted',
  'RMAT-PEND': 'RMAT Exam is Pending',
  'RMAT-PASS': 'RMAT Pass',
  'RMAT-FAIL': 'RMAT Fail',
  'ENRL-ACCEPTED': 'Application Accepted',
  'PROG-FEE-PEND': 'Qualification Fee Pending',
  'BURSARY-REQUESTED': 'Request for Bursary',
  'BURSARY-DOC-VER-PEND': 'Bursary Document Verification Pending',
  'BURSARY-DOC-REQUESTED': 'Bursary Documents Requested',
  'BURSARY-PEND': 'Bursary Confirmation Pending',
  'BURSARY-APPROVED': 'Bursary Approved',
  'BURSARY-REJECTED': 'Bursary Rejected',
  'LOAN-REQUESTED': 'Request for Loan',
  'LOAN-DOC-VER-PEND': 'Loan Document Verification Pending',
  'LOAN-DOC-REQUESTED': 'Loan Documents Requested',
  'LOAN-PEND': 'Loan Confirmation Pending',
  'LOAN-APPROVED': 'Loan Approved',
  'LOAN-REJECTED': 'Loan Rejected',
  'PROG-FEE-DOC-VER-PEND': 'Qualification Fees Document Verification Pending',
  'RESUB-PROG-FEE-PROOF': 'Resubmit Program Fee  POP',
  'PROG-FEE-VER-PEND': 'Program Fees Verification Pending',
  'DEBIT-ORDER-FORM-PEND': 'Debit Order Form Pending',
  'DEBIT-ORDER-FORM-DOC-VER-PEND': 'Debit Order Form Document Verification Pending',
  'DEBIT-ORDER-FORM-VER-PEND': 'Debit Order Form Verification Pending',
  'DEBIT-ORDER-FORM-ACCEPTED': 'Debit Order Form Accepted',
  'RESUB-DEBIT-ORDER-FORM': 'Resubmit Debit Order Form',
  'EFT-LETTER-PEND': 'EFT Letter Pending',
  'EFT-LETTER-DOC-VER-PEND': 'EFT Letter Document Verification Pending',
  'EFT-LETTER-VER-PEND': 'EFT Letter Verification Pending',
  'EFT-LETTER-ACCEPTED': 'EFT Letter Accepted',
  'RESUB-EFT-LETTER': 'Resubmit EFT Letter',
  'PROG-FEE-ACCEPTED': 'Qualification Fee Accepted',
  'INTAKE-ASSIGNMENT-PEND': 'Intake Assignment Pending',
  'INTAKE-ASSIGNED': 'Intake Assigned',
  'PROG-ADMITTED': 'Enrolled',
  ENROLLED: 'Enrolled to the Program',
  'APP-DRAFT': 'In Draft',
  'APP-FEE-PEND': 'Application  Fee Pending',
  'UPLD-APP-DOC': 'Upload Application documents',
  'APP-DOC-UPLOADED': 'Application Documents Uploaded',
  'RESUB-APP-DOC': 'Resubmit Application Documents',
  'UPLD-BURSARY-DOC': 'Upload Bursary Documents',
  'BURSARY-DOC-UPLOADED': 'Bursary Document Uploaded',
  'RESUB-BURSARY-DOC': 'Resubmit Bursary Documents',
  'BURSARY-DOC-ACCEPTED': 'Bursary Documents Accepted',
  'UPLD-LOAN-DOC': 'Upload Loan Documents',
  'LOAN-DOC-UPLOADED': 'Loan Document Uploaded',
  'RESUB-LOAN-DOC': 'Resubmit Loan Documents',
  'LOAN-DOC-ACCEPTED': 'Loan Documents Accepted',
  'INTAKE-ASSIGNMENT PENDING': 'Intake Assignment Pending',
  'RMAT-PENDING': 'RMAT Exam is Pending',
  'ROLLOVER-FEE-PEND': 'Rollover Fee Pending',
  'ADV-PROG-FEE-PENDING': 'Advance Qualification Fee Pending',
  SUSPENDED: 'Suspended',
  CANCELLED: 'Cancelled',
  GRADUATED: 'Graduated',
  COMPLETED: 'Completed',
  EXPELLED: 'Expelled',
  ATTENDED: 'Attended',
  DECEASED: 'Deceased',
  LEAD: 'Lead',
  'INTAKE-ASSIGNMENT-PENDING': 'Intake Assignment Pending',
  'FINANCE-VERIFICATION-PEND': 'Finance Verification Pending',
  'RESUB-RPL-FEE': 'Resubmit Rpl Fee POP',
  MONTHLY_PAYMENT_REJECTED: 'Monthly Payment Rejected',
  'BURSARY-LETTER-PEND': 'Bursary Letter Pending',
  'RPL-FEE-PEND': 'Rpl Fee Pending',
  'RPL-FEE-REJECT': 'Rpl Fee Rejected',
  'RPL-FEE-ACCEPTED': 'Rpl Fee Accepted',
  'RPL-FEE-VER-PEND': 'Rpl Fee Verification Pending',
  DEFERRED: 'Deferred',
  'OFF-FEE-VER-PEND': 'Offline Fees Verification Pending',
  'OFF-FEE-REJ': 'Offline Fees Rejected'
}

export enum AcademicStatusEnum {
  PASS = 'Pass',
  FAIL = 'Fail',
  DEFAULT = '-',
  PASSWITHDISTINCTION = 'Pass with distinction',
  INCOMPLETE = '--',
  Exempted = 'Exempted',
  NULL = 'null',
  NOTYETCOMPLETED = 'Not yet completed'
}

export const applicationStatusColor: {
  [key: string]: ThemeColor
} = {
  'APP-DRAFT': 'secondary',
  'APP-FEE-PEND': 'warning',
  'APP-FEE-VER-PEND': 'warning',
  'RESUB-APP-FEE-PROOF': 'warning',
  'APP-FEE-ACCEPTED': 'success',
  'APP-ENROLLED': 'success',
  'UPLD-APP-DOC': 'warning',
  'APP-DOC-UPLOADED': 'success',
  'RESUB-APP-DOC': 'warning',
  'APP-DOC-ACCEPTED': 'success',
  'RMAT-PEND': 'warning',
  'RMAT-PASS': 'success',
  'RMAT-FAIL': 'error',
  'ENRL-ACCEPTED': 'success',
  'PROG-FEE-PEND': 'warning',
  'BURSARY-REQUESTED': 'warning',
  'UPLD-BURSARY-DOC': 'warning',
  'BURSARY-DOC-UPLOADED': 'success',
  'RESUB-BURSARY-DOC': 'warning',
  'BURSARY-DOC-ACCEPTED': 'info',
  'BURSARY-PEND': 'warning',
  'BURSARY-APPROVED': 'info',
  'BURSARY-REJECTED': 'error',
  'LOAN-REQUESTED': 'primary',
  'UPLD-LOAN-DOC': 'warning',
  'LOAN-DOC-UPLOADED': 'success',
  'RESUB-LOAN-DOC': 'warning',
  'LOAN-DOC-ACCEPTED': 'info',
  'LOAN-PEND': 'warning',
  'LOAN-APPROVED': 'info',
  'LOAN-REJECTED': 'error',
  'PROG-FEE-VER-PEND': 'warning',
  'RESUB-PROG-FEE-PROOF': 'warning',
  'PROG-FEE-ACCEPTED': 'info',
  'INTAKE-ASSIGNMENT PENDING': 'warning',
  'INTAKE-ASSIGNED': 'info',
  'PROG-ADMITTED': 'primary',
  ENROLLED: 'primary',
  'APP-FEE-DOC-VER-PEND': 'warning',
  'APP-FEE-REJECTED': 'error',
  'APP-DOC-VER-PEND': 'warning',
  'APP-DOC-REQUESTED': 'primary',
  'BURSARY-DOC-VER-PEND': 'warning',
  'BURSARY-DOC-REQUESTED': 'primary',
  'LOAN-DOC-VER-PEND': 'warning',
  'LOAN-DOC-REQUESTED': 'primary',
  'PROG-FEE-DOC-VER-PEND': 'warning',
  'DEBIT-ORDER-FORM-PEND': 'warning',
  'DEBIT-ORDER-FORM-DOC-VER-PEND': 'warning',
  'DEBIT-ORDER-FORM-VER-PEND': 'warning',
  'DEBIT-ORDER-FORM-ACCEPTED': 'info',
  'RESUB-DEBIT-ORDER-FORM': 'error',
  'EFT-LETTER-PEND': 'warning',
  'EFT-LETTER-DOC-VER-PEND': 'warning',
  'EFT-LETTER-VER-PEND': 'warning',
  'EFT-LETTER-ACCEPTED': 'info',
  'RESUB-EFT-LETTER': 'error',
  'INTAKE-ASSIGNMENT-PEND': 'warning',
  CANCELLED: 'error',
  SUSPENDED: 'error',
  EXPELLED: 'error',
  GRADUATED: 'primary',
  DEFERRED: 'warning',
  'RPL-FEE-PEND': 'warning',
  'RPL-FEE-REJECT': 'error',
  'RPL-FEE-ACCEPTED': 'primary',
  'RPL-FEE-VER-PEND': 'warning',
  'ADV-PROG-FEE-PENDING': 'warning',
  DECEASED: 'secondary',
  LEAD: 'info',
  'BURSARY-APP-FEE-PEND': 'warning',
  'INTAKE-ASSIGNMENT-PENDING': 'warning',
  'RMAT-PENDING': 'warning',
  SALES: 'info',
  PENDING: 'warning',
  FINANCE: 'error',
  'INTAKE-PENDING': 'warning',
  STUDYING: 'warning',
  DISCONTINUED: 'error',
  ASSIGNMENTFAILED: 'error',
  EXAMFAILED: 'error'
}

interface IApplicationStatusSubStatusAndColor {
  label: string
  color: ThemeColor
}

export const getApplicationStatusSubStatusAndColor = (
  status: string,
  subStatus: string | null
): IApplicationStatusSubStatusAndColor => {
  const label =
    status && subStatus
      ? studentApplicationAllStatus?.[status] + '-' + studentApplicationSubStatus?.[subStatus]
      : studentApplicationAllStatus?.[status]

  if (status === 'GRADUATED') {
    if (subStatus && ['SUB-GRADUATED', 'SUB-MARKS-NOT-RETRIEVED'].includes(subStatus)) {
      return { label, color: 'success' }
    }

    return { label, color: subStatus ? 'warning' : 'success' }
  }
  if (status === 'COMPLETED') {
    if (subStatus === 'SUB-COMPLETED') {
      return { label, color: 'success' }
    }

    return { label, color: subStatus ? 'warning' : 'success' }
  }

  return { label, color: applicationStatusColor[status?.toUpperCase()] || 'secondary' }
}

export interface ISubProgramData {
  id?: number
  code: string
  name: string
  nqfLevel: string
}

export interface IAddSubProgram {
  programCode?: string
  code: string
  name: string
  nqfLevel: string
}

interface UserStatusType {
  [key: string]: ThemeColor
}

export const userStatusObj: UserStatusType = {
  'ENRL-ACCEPTED': 'primary',
  'APP-FEE-DOC-VER-PEND': 'warning',
  sales: 'info',
  'APP-FEE-ACCEPTED': 'error'
}

export const queryDashboardStatus: UserStatusType = {
  Solved: 'primary',
  Open: 'error'
}
export const riskDashboardStatus: UserStatusType = {
  assignmentFailed: 'error',
  examFailed: 'error',
  deffered: 'primary',
  SUSPENDED: 'secondary',
  CANCELLED: 'error',
  EXPELLED: 'error'
}
export const resultStatus: UserStatusType = {
  Pass: 'success',
  'Pass with Distinction': 'primary'
}

export const status: LoginParams = {
  successCode: 200,
  successCodeOne: 201,
  unauthorizedStatus: 401,
  successCodeArr: [200, 201],
  badRequestCode: 400,
  approve: 'APPROVED',
  reject: 'REJECT',
  enrolled: 'Enrolled',
  local: 'LOCAL'
}

type LoginParams = {
  successCode: number
  successCodeOne: number
  badRequestCode: number
  successCodeArr: Array<number>
  unauthorizedStatus: number
  approve: string
  reject: string
  enrolled: string
  local: string
}

export enum documentStatus {
  pending = 'PENDING',
  approved = 'APPROVED',
  rejected = 'REJECTED',
  salesApproved = 'SALES_APPROVED',
  salesReject = 'SALES_REJECT',
  financeApproved = 'FINANCE_APPROVED',
  financeReject = 'FINANCE_REJECT',
  admissionApproved = 'ADMISSION_APPROVED',
  admissionReject = 'ADMISSION_REJECT',
  FinanceVerified = 'FINANCE_VERIFIED',
  AffordableRank = 'AFFORDABLE-RANK',
  EdForAllContract = 'EDFORALLCONTRACT',
  Study_Flexi_Calculation = 'STUDY-FLEXI-CALCULATION',
  Study_Flexi_Agreement = 'STUDY-FLEXI-AGREEMENT'
}

export enum StudentInformationStatus {
  MobileNumberInvalid = 'Contact Number should be number',
  FirstNameRequired = ' First Name is Required',
  FirstNameError = 'First name must be character  ',
  LastNameRequired = 'last Name is Required',
  LastNameError = 'last Name must be character',
  ContactRequired = 'contact number is required',
  EmailRequired = 'email is required',
  StreetNameRequired = 'Address is required',
  CountryNameRequired = 'Country is required',
  CityNameRequired = 'city is required',
  StateNameRequired = 'state is required',
  ZipcodeRequired = 'Zip is required',
  CostOfTrainingQuoteRequired = 'Cost Of TrainingQuoted is required',
  ContractCostRequired = 'Contract Cost is required',
  VarianceRequired = 'Variance  is required',
  VarianceDetailRequired = 'Variance Details  is required',
  PaymentTypeRequired = 'Payment Type is required',
  InstallmentNameRequired = 'InstallmentName is required',
  CurrencyRequired = 'Currency is required',
  DueAmountRequired = 'DueAmount is required',
  DateRequired = 'Date is required',
  AccommodationRequired = 'Accommodation  is required',
  CarHireRequired = 'Car Hire is required',
  FlightsRequired = 'Flights is required',
  VenueCostIncludedRequired = 'Venue Cost Included is required',
  CateringRequired = 'Catering Include is required',
  MobileNumber = 'Contact Number Required',
  Address = 'Address is Required',
  SponsorType = 'Sponsor Type Required',
  RelatioshipType = 'Relationship Type Required',
  SponsorName = 'Sponsor Name is Required',
  RelationShipType = 'RelationShip Type Required',
  NationalityStatus = 'Nationality Status is required',
  Gender = 'Gender is required',
  DateOfBirth = 'Date Of Birth is required',
  Race = 'Race is Required',
  Language = 'Home Language is required',
  PermanentResident = 'Permanent Resident  is required',
  Nationality = 'Nationality is required',
  DocumentType = 'Document Type is required',
  IdentificationNumber = 'Identification Number is required',
  DueAmountRequiredError = 'Amount Must be only digits',
  FullNameRequired = ' Full Name is Required',
  FullNameError = 'Full name must be character  ',
  Relationship = 'Relationship is required',
  ZipCodeNumber = 'Zip code must be numbers',
  CityNameInvalid = 'City name must be characters',
  MiddleNameError = 'Middle name must be character  ',
  IdentificationNumberAplhaNumeric = 'Identification Number must be alphanumeric'
}

export interface InvoiceType {
  lead: any
  id: string
  queryCode: string
  studentCode: string
  firstName: string
  lastName: string
  email: string
  subject: string
  queryType: string
  submittedOn: string
  closedOn: string
  status: string
  contactNumber: string
  programName: string
  description: string
  assign: string
  comment: string
  document?: string
  mobileNo: string
  mobileCountryCode: string
  documentName: string
  createdAt: any
  updatedAt: any
  documentCode: string
  programCode: string
  supportingDocumentCode: string
}
export interface AcFormType {
  id: string
  studentId: string
  studentName: string
  email: string
  natureOfRequest: string
  document: string
  submittedOn: string
  assigned: string
  status: string
  contactNumber: string
  programName: string
  description: string
  assign: string
}

export interface IThroughputStatusTypes {
  id: string
  number: string
  percent: string
  enrollment: string
}

export const EfilteredDataValues = {
  all: 'All'
}

export interface IPublishMarksRow {
  filter(arg0: (i: { id: number }) => boolean): unknown
  id: number
  studentCode: string
  assessment: number
  assignments: number
  examination: number
  course: {
    name: string
  }
  isAssessmentPublish: boolean
  isAssignmentPublish: boolean
  isExaminationPublish: boolean
  assessmentPublishDate: SetStateAction<string>
}

export enum OASMSRole {
  Sales = 'Sales',
  Admin = 'Admin',
  Admission = 'Admission',
  CorporateSales = 'Corporate_Sales',
  Academics = 'Academics',
  Assessment = 'Assessment',
  CRM = 'CRM',
  FINANCE = 'Finance',
  OPERATION = 'Operation'
}

export const AgentRole: any = {
  Sales: 'Admin_Sales',
  Admin: 'Admin_Sales',
  Admission: 'Admin_Admission',
  CorporateSales: 'Admin_Corporate_Sales',
  Academics: 'Admin_Academics',
  Assessment: 'Admin_Assessment',
  CRM: 'Admin_Corporate_Sales',
  FINANCE: 'Admin_Finance',
  OPERATION: 'Admin_Operation'
}
interface IAttendanceRecordStatusTypes {
  PARTIALLY_ATTENDED: string
  ATTENDED: string
  PENDING: string
  SKIPPED: string
}

export const AttendanceRecordStatus: IAttendanceRecordStatusTypes = {
  PARTIALLY_ATTENDED: 'PARTIALLY-ATTENDED',
  ATTENDED: 'ATTENDED',
  PENDING: 'PENDING',
  SKIPPED: 'SKIPPED'
}
export const AttendanceStatus: IAttendanceRecordStatusTypes = {
  PARTIALLY_ATTENDED: 'Partially Attended',
  ATTENDED: 'Attended',
  PENDING: 'Pending',
  SKIPPED: 'Skipped'
}
interface IClassRecordStatusTypes {
  re_assigned: string
  not_assigned: string
  assigned: string
  complete: string
}
export const ClassRecordStatus: IClassRecordStatusTypes = {
  not_assigned: 'NOT-ASSIGNED',
  re_assigned: 'RE-ASSIGNED',
  assigned: 'ASSIGNED',
  complete: 'COMPLETE'
}
export const ClassStatus: IClassRecordStatusTypes = {
  not_assigned: 'Not-Assigned',
  re_assigned: 'Re-Assigned',
  assigned: 'Assigned',
  complete: 'Complete'
}
export interface IFilterPayload {
  fromDate: string
  toDate: string
  enrolmentStatus: string
  qualification: string
  race: string
  school: string
  intake: string
  classType: string
}
export interface IFilterParams {
  fromDate: Date | null
  toDate: Date | null
  status?: string
  programCode?: string
  enrolmentStatus?: string
  qualification?: string
  race: string
  gender?: string
  intake: string
  school: string
  classType: string
}

export interface IStudentStatusParams {
  ENROLLED: string
  CANCELLED: string
  GRADUATED: string
  DEFERRED: string
  EXPELLED: string
  DECEASED: string
}
export enum QueryFileSize {
  maxSize = 500 * 1024 // 500KB
}
export const FileType = ['image/png', 'image/pdf', 'image/jpeg']
export enum DocumentsType {
  QueryDoc = 'QUERYDOC'
}
export enum QueryFileError {
  fileSizeError = 'File is larger than 500 KB',
  fileTypeError = 'File type must be png, jpeg and pdf'
}
interface downloadSuccess {
  download: string
  upload: string
  searchErrorMessage: string
  passwordReset: string
  passwordUpdate: string
  academicDownload: string
  studentCodeError: string
  queryCreated: string
}

export const downloadSuccess: downloadSuccess = {
  download: 'File downloaded successfully.',
  upload: 'File uploaded successfully.',
  searchErrorMessage: 'Type minimum 3 characters',
  passwordReset: 'Password reset request was sent successfully. Please check your email to reset your password.',
  passwordUpdate: 'Password update successfully',
  academicDownload: 'Progress Report & downloaded successfully.',
  studentCodeError: 'Student code does not exist in academic record',
  queryCreated: 'Your request was successfully submitted.'
}
interface IStudentStatusCodeTypes {
  pending: Array<string>
  approval: Array<string>
  rejects: Array<string>
  managementCode: Array<string>
}
export const studentStatusCode: IStudentStatusCodeTypes = {
  pending: [
    'APP-FEE-PEND',
    'APP-FEE-DOC-VER-PEND',
    'APP-FEE-VER-PEND',
    'RMAT-PEND',
    'PROG-FEE-PEND',
    'BURSARY-REQUESTED',
    'BURSARY-DOC-REQUESTED',
    'BURSARY-PEND',
    'LOAN-REQUESTED',
    'LOAN-DOC-VER-PEND',
    'LOAN-DOC-REQUESTED',
    'LOAN-PEND',
    'PROG-FEE-DOC-VER-PEND',
    'PROG-FEE-VER-PEND',
    'BURSARY-APP-FEE-PEND'
  ],
  approval: [
    'ENRL-ACCEPTED',
    'APP-FEE-ACCEPTED',
    'APP-DOC-ACCEPTED',
    'RMAT-PASS',
    'BURSARY-APPROVED',
    'LOAN-APPROVED',
    'PROG-FEE-ACCEPTED'
  ],
  rejects: [
    'APP-REJECTED',
    'APP-FEE-REJECTED',
    'RMAT-FAIL',
    'BURSARY-REJECTED',
    'RESUB-APP-FEE-PROOF',
    'RESUB-PROG-FEE-PROOF'
  ],
  managementCode: ['PROG-ADMITTED']
}
interface IStudentStatusTypes {
  pending: string
  reject: string
  approved: string
  admitted: string
  activityStatus: string
  bursaryStatus: string
  retailStatus: string
}

export const studentStatus: IStudentStatusTypes = {
  pending: 'Review pending',
  reject: 'Rejected',
  approved: 'Approved',
  admitted: 'Admitted',
  activityStatus: 'LOCAL',
  bursaryStatus: 'BURSARY',
  retailStatus: 'RETAIL'
}
export const queryStatus = {
  solve: 'SOLVED',
  unsolved: 'UNSOLVED',
  open: 'OPEN'
}
export interface IStudentDataRecord {
  data: IdataParams[]
  count: number
}

export interface IdataParams {
  isActive: boolean
  id: number
  firstName: string
  lastName: string
  email: string
  mobileNumber: string
  mobileCountryCode: string
  dateOfBirth: string
  identificationNumber: string
  applicationCode: string
  status: string
  studentCode: string
  intakeCode: string
  intakeAcademicYear: number
  SsaCode: string
  SsaStatus: string
  registrationDate: string
  enrolmentDate: string
  education: IEducationParams[]
}

export interface IEducationParams {
  isActive: boolean
  id: number
  programCode: string
  programName: string
  studyModeCode: string
  studyTypeCode: string
  studentTypeCode: string
  agentCode: string
}

export const mandatorySponsorModeFeilds = ['GUARDIAN', 'BURSARY']

export enum GoogleAnalyticsScript {
  script1 = 'https://regenesys-rms.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/tod1zk/b/5/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=236dc7e1',
  script2 = 'https://regenesys-rms.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/tod1zk/b/5/b0105d975e9e59f24a3230a22972a71a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=236dc7e1',
  prodURL = 'https://rms.regenesys.net/'
}

export const URLArray = ['/', '/login', '/login/']

export const enrollmentStatusListData = [
  {
    name: 'Admitted',
    code: 'PROG-ADMITTED'
  },
  {
    name: 'Expelled',
    code: 'EXPELLED'
  },
  {
    name: 'Cancelled',
    code: 'CANCELLED'
  },
  {
    name: 'Deferred',
    code: 'DEFERRED'
  },
  {
    name: 'Deceased',
    code: 'DECEASED'
  },
  {
    name: 'Graduated',
    code: 'GRADUATED'
  }
]

export const documentMessage: IDynamicObject = {
  'file-invalid-type': 'Only Excel files are Allowed',
  'file-too-large': 'File is larger than 200 KB'
}

export enum DocumentType {
  PaymentProof = 'PAYMENTPROOF',
  AcceptanceLetter = 'ACCEPTANCE-LETTER',
  BursaryLetter = 'BURSARYLETTER',
  FinanceVerified = 'FINANCE_VERIFIED',
  RegenerateQuote = 'Regenerate-Quote',
  AffordableRank = 'AFFODABLE-RANK',
  Quote = 'QUOTE',
  TermsAndConditions = 'TERMSANDCONDITION',
  PassPort = 'PASSPORT',
  Study_Flexi_Calculation = 'STUDY-FLEXI-CALCULATION',
  Study_Flexi_Agreement = 'STUDY-FLEXI-AGREEMENT',
  LOAN_SANCTION_LETTER = 'LOAN_SANCTION_LETTER',
  LOAN_DISBURSEMENT_LETTER = 'LOAN_DISBURSEMENT_LETTER',
  SAQA_certificate = 'SAQA-CERTIFICATE',
  Matriculation_Board_Certificate = 'MATRICULATION-BOARD-CERTIFICATE',
  AC_Form = 'AC-FORM',
  Marriage_Certificate = 'MARRIAGE-CERTIFICATE',
  Updated_ID_for_Change_of_Names = 'UPDATE-ID-FOR-CHANGE-NAME',
  Completion_Plan = 'COMPLETION-PLAN',
  Exemption_Form = 'EXEMPTION-FORM',
  AOD_Agreement = 'AOD-AGREEMENT',
  IDPassport = 'IDPASSPORT',
  ResumeCV = 'RESUMECV',
  HighestQualification = 'HIGHESTQUALIFICATION',
  DeclarationForm = 'DECLARATIONFORM',
  MotivationLetter = 'MOTIVATIONLETTER',
  InterviewNotes = 'INTERVIEWNOTES',
  MatricCertificate = 'MATRIC',
  ApplicationLetter = 'APPLICATIONLETTER',
  Others = 'OTHERS',
  EdForAllContract = 'EDFORALLCONTRACT',
  DebitOrder = 'DEBITORDER'
}

export const GraduationListMessage = {
  Success: 'Data fetched Successfully.',
  Error: 'Something went wrong.',
  NoData: 'No records exists.',
  ExamAttendance: 'Exam Attendance list loaded sucessfully.',
  ExcelExport: 'Exam Attendance list exported sucessfully.'
}

export const graduationStatus: any = {
  subGraduated: 'SUB-GRADUATED',
  subMarkNotRetrived: 'SUB-MARKS-NOT-RETRIEVED',
  subGraduatedFeesPending: 'SUB-GRADUATED-FEES-PENDING'
}

export const testMetricTypes = {
  numeric: 'Numeric',
  cnyc: 'C/Nyc',
  passfail: 'Pass/Fail'
}

export const allRoles = {
  application: 'application',
  enrolment: 'enrolment',
  admission: 'admission',
  assignIntake: 'assignIntake',
  admittedStudent: 'admittedStudent',
  studentRecord: 'studentRecord',
  operation: 'operation'
}

export enum AcademicSymbols {
  APLUS = 'A+',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  DEFAULT = '-'
}

export const StudentQualificationStatuses = [
  { label: 'Bursary Application Fee Pending', value: 'BURSARY-APP-FEE-PEND' },
  { label: 'Application Fee Verification Pending', value: 'APP-FEE-DOC-VER-PEND' },
  { label: 'Resubmit Application Fee POP', value: 'RESUB-APP-FEE-PROOF' },
  { label: 'Application Fee Accepted', value: 'APP-FEE-ACCEPTED' },
  { label: 'Application Fee Rejected', value: 'APP-FEE-REJECTED' },
  { label: 'Application Confirmed', value: 'APP-ENROLLED' },
  { label: 'Application Document Verification Pending', value: 'APP-DOC-VER-PEND' },
  { label: 'Application Documents Requested', value: 'APP-DOC-REQUESTED' },
  { label: 'Application Documents Accepted', value: 'APP-DOC-ACCEPTED' },
  { label: 'RMAT Exam is Pending', value: 'RMAT-PEND' },
  { label: 'RMAT Pass', value: 'RMAT-PASS' },
  { label: 'RMAT Fail', value: 'RMAT-FAIL' },
  { label: 'Application Accepted', value: 'ENRL-ACCEPTED' },
  { label: 'Qualification Fee Pending', value: 'PROG-FEE-PEND' },
  { label: 'Request for Bursary', value: 'BURSARY-REQUESTED' },
  { label: 'Bursary Document Verification Pending', value: 'BURSARY-DOC-VER-PEND' },
  { label: 'Bursary Documents Requested', value: 'BURSARY-DOC-REQUESTED' },
  { label: 'Bursary Confirmation Pending', value: 'BURSARY-PEND' },
  { label: 'Bursary Approved', value: 'BURSARY-APPROVED' },
  { label: 'Bursary Rejected', value: 'BURSARY-REJECTED' },
  { label: 'Request for Loan', value: 'LOAN-REQUESTED' },
  { label: 'Loan Document Verification Pending', value: 'LOAN-DOC-VER-PEND' },
  { label: 'Loan Documents Requested', value: 'LOAN-DOC-REQUESTED' },
  { label: 'Loan Confirmation Pending', value: 'LOAN-PEND' },
  { label: 'Loan Approved', value: 'LOAN-APPROVED' },
  { label: 'Loan Rejected', value: 'LOAN-REJECTED' },
  { label: 'Qualification Fees Document Verification Pending', value: 'PROG-FEE-DOC-VER-PEND' },
  { label: 'Resubmit Program Fee  POP', value: 'RESUB-PROG-FEE-PROOF' },
  { label: 'Program Fees Verification Pending', value: 'PROG-FEE-VER-PEND' },
  { label: 'Debit Order Form Pending', value: 'DEBIT-ORDER-FORM-PEND' },
  { label: 'Debit Order Form Document Verification Pending', value: 'DEBIT-ORDER-FORM-DOC-VER-PEND' },
  { label: 'Debit Order Form Verification Pending', value: 'DEBIT-ORDER-FORM-VER-PEND' },
  { label: 'Debit Order Form Accepted', value: 'DEBIT-ORDER-FORM-ACCEPTED' },
  { label: 'Resubmit Debit Order Form', value: 'RESUB-DEBIT-ORDER-FORM' },
  { label: 'EFT Letter Pending', value: 'EFT-LETTER-PEND' },
  { label: 'EFT Letter Document Verification Pending', value: 'EFT-LETTER-DOC-VER-PEND' },
  { label: 'EFT Letter Verification Pending', value: 'EFT-LETTER-VER-PEND' },
  { label: 'EFT Letter Accepted', value: 'EFT-LETTER-ACCEPTED' },
  { label: 'Resubmit EFT Letter', value: 'RESUB-EFT-LETTER' },
  { label: 'Qualification Fee Accepted', value: 'PROG-FEE-ACCEPTED' },
  { label: 'Intake Assignment Pending', value: 'INTAKE-ASSIGNMENT-PEND' },
  { label: 'Intake Assigned', value: 'INTAKE-ASSIGNED' },
  { label: 'Enrolled', value: 'PROG-ADMITTED' },
  { label: 'Enrolled to the Program', value: 'ENROLLED' },
  { label: 'In Draft', value: 'APP-DRAFT' },
  { label: 'Application  Fee Pending', value: 'APP-FEE-PEND' },
  { label: 'Upload Application documents', value: 'UPLD-APP-DOC' },
  { label: 'Application Documents Uploaded', value: 'APP-DOC-UPLOADED' },
  { label: 'Resubmit Application Documents', value: 'RESUB-APP-DOC' },
  { label: 'Upload Bursary Documents', value: 'UPLD-BURSARY-DOC' },
  { label: 'Bursary Document Uploaded', value: 'BURSARY-DOC-UPLOADED' },
  { label: 'Resubmit Bursary Documents', value: 'RESUB-BURSARY-DOC' },
  { label: 'Bursary Documents Accepted', value: 'BURSARY-DOC-ACCEPTED' },
  { label: 'Upload Loan Documents', value: 'UPLD-LOAN-DOC' },
  { label: 'Loan Document Uploaded', value: 'LOAN-DOC-UPLOADED' },
  { label: 'Resubmit Loan Documents', value: 'RESUB-LOAN-DOC' },
  { label: 'Loan Documents Accepted', value: 'LOAN-DOC-ACCEPTED' },
  { label: 'Suspended', value: 'SUSPENDED' },
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'Graduated', value: 'GRADUATED' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Expelled', value: 'EXPELLED' },
  { label: 'Attended', value: 'ATTENDED' },
  { label: 'Deceased', value: 'DECEASED' },
  { label: 'Lead', value: 'LEAD' },
  { label: 'Finance Verification Pending', value: 'FINANCE-VERIFICATION-PEND' },
  { label: 'Monthly Payment Rejected', value: 'MONTHLY_PAYMENT_REJECTED' },
  { label: 'Bursary Letter Pending', value: 'BURSARY-LETTER-PEND' },
  { label: 'Rpl Fee Pending', value: 'RPL-FEE-PEND' },
  { label: 'Rpl Fee Rejected', value: 'RPL-FEE-REJECT' },
  { label: 'Rpl Fee Accepted', value: 'RPL-FEE-ACCEPTED' },
  { label: 'Rpl Fee Verification Pending', value: 'RPL-FEE-VER-PEND' },
  { label: 'Deferred', value: 'DEFERRED' }
]

export const CumLauseStatuses = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
]

export const IntakeHeaders = [
  { id: 1, minWidth: 50, flex: 0.15, name: '#' },
  {
    id: 2,
    minWidth: 300,
    flex: 1,
    name: 'Intake Name'
  },
  {
    id: 3,
    flex: 1,
    minWidth: 230,
    name: 'Code'
  },
  {
    id: 4,
    flex: 1,
    minWidth: 100,
    name: 'Actions'
  }
]

export const EXEMPTED = 'Exempted'

export const enum AcademicTranscript {
  download = 'Academic Transcript downloaded successfully.',
  progressDownload = 'Progress Report downloaded successfully.'
}

export const qualificationAcrSettings = [
  {
    category: 'Formative Assessment',
    test_type: 'Digital Assessment',
    weightAge: true,
    subminimum: false
  },
  {
    category: 'Formative Assessment',
    test_type: 'Assignment',
    weightAge: true,
    subminimum: false
  },
  {
    category: 'Summative Assessment',
    test_type: 'Examination',
    weightAge: true,
    subminimum: false
  },
  {
    category: 'Final Result',
    test_type: 'Total',
    weightAge: true,
    subminimum: false
  },
  {
    category: 'Final Result',
    test_type: 'Status',
    weightAge: true,
    subminimum: false
  },
  {
    category: 'Final Result',
    test_type: 'Symbol',
    weightAge: true,
    subminimum: false
  }
]

export enum ActivityActionBy {
  'SYSTEM-TRIGGERED' = 'System Triggered'
}
